import React from 'react';

// Busable primary purple speech bubble style Start/Finish markers
export const StartTextMarker = ({ onClick }) => (
    <div 
        style={{
            position: 'relative',
            cursor: 'pointer'
        }}
        onClick={onClick}
    >
        {/* Speech bubble with proper tail */}
        <div style={{
            position: 'relative',
            background: '#6f42c1',
            color: 'white',
            padding: '8px 12px',
            borderRadius: '18px',
            fontSize: '10px',
            fontWeight: '600',
            textAlign: 'center',
            minWidth: '60px',
            boxShadow: '0 4px 12px rgba(107, 70, 193, 0.3), 0 2px 4px rgba(0,0,0,0.1)',
            backdropFilter: 'blur(10px)',
            transition: 'all 0.2s ease-in-out',
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            border: '1px solid rgba(255,255,255,0.2)',
            marginBottom: '8px' // Space for tail
        }}
        onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.05)';
            e.target.style.boxShadow = '0 6px 16px rgba(107, 70, 193, 0.4), 0 4px 8px rgba(0,0,0,0.15)';
        }}
        onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.boxShadow = '0 4px 12px rgba(107, 70, 193, 0.3), 0 2px 4px rgba(0,0,0,0.1)';
        }}
        >
            START
        </div>
        
        {/* Speech bubble tail pointing down to location */}
        <div style={{
            position: 'absolute',
            bottom: '-8px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '0',
            height: '0',
            borderLeft: '8px solid transparent',
            borderRight: '8px solid transparent',
            borderTop: '12px solid #6B46C1',
            filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
        }} />
    </div>
);

export const FinishTextMarker = ({ onClick }) => (
    <div 
        style={{
            position: 'relative',
            cursor: 'pointer'
        }}
        onClick={onClick}
    >
        {/* Speech bubble with proper tail */}
        <div style={{
            position: 'relative',
            background: '#6B46C1',
            color: 'white',
            padding: '8px 12px',
            borderRadius: '18px',
            fontSize: '10px',
            fontWeight: '600',
            textAlign: 'center',
            minWidth: '60px',
            boxShadow: '0 4px 12px rgba(107, 70, 193, 0.3), 0 2px 4px rgba(0,0,0,0.1)',
            backdropFilter: 'blur(10px)',
            transition: 'all 0.2s ease-in-out',
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            border: '1px solid rgba(255,255,255,0.2)',
            marginBottom: '8px' // Space for tail
        }}
        onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.05)';
            e.target.style.boxShadow = '0 6px 16px rgba(107, 70, 193, 0.4), 0 4px 8px rgba(0,0,0,0.15)';
        }}
        onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.boxShadow = '0 4px 12px rgba(107, 70, 193, 0.3), 0 2px 4px rgba(0,0,0,0.1)';
        }}
        >
            FINISH
        </div>
        
        {/* Speech bubble tail pointing down to location */}
        <div style={{
            position: 'absolute',
            bottom: '-8px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '0',
            height: '0',
            borderLeft: '8px solid transparent',
            borderRight: '8px solid transparent',
            borderTop: '12px solid #6B46C1',
            filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
        }} />
    </div>
); 